


export function ListYearMonth(startMonth, endMonth) {
    var list = [];

    var year = parseInt(startMonth.substr(0, 4));
    var month = parseInt(startMonth.substr(5));

    var eYear = parseInt(endMonth.substr(0, 4));
    var eMonth = parseInt(endMonth.substr(5)); 
    
    var ym = 0;
    while (year < eYear) {
        if (month < 10) {
            ym = String(year) + "-0" + String(month);
        } else {
            ym = String(year) + "-" + String(month);
        }
        
        list.push(ym);

        month += 1;
        if (month >= 13) {
            year += 1;
            month = 1;
        }
    }

    while (month < eMonth) {
        if (month < 10) {
            ym = String(year) + "-0" + String(month);
        } else {
            ym = String(year) + "-" + String(month);
        }
        list.push(ym);

        month += 1;
    }
        
    list.push(endMonth);
    return list;
}

export function ListYearMonthWithStep(start, end, step) {
    var full = ListYearMonth(start, end);

    var list = [];
    for (var i = 0; i < full.length; i += step) {
        list.push(full[i]);
    }

    return list;
}

export function LoadJsonFile(url) {
    var request = new XMLHttpRequest();
    request.open("get", url, false);             // 设置请求方法与路径

    var jsonData = null;
    request.onload = function () {        // XHR对象获取到返回信息后执行
        if (request.status == 200) {      // 返回状态为200，即为数据获取成功
            jsonData = JSON.parse(request.responseText);
        }
    }
    
    request.send(null);                   // 不发送数据到服务器    
    return jsonData;
}